import { Franchise } from "../../../types/Franchise";
import { Client } from "../Client";
import { APIRequest, APIRequestMethod } from "../APIRequest";
import { Office } from "../../../types/Office";

class FranchiseAPI {
    Get(franchiseId: string): Promise<Franchise> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/franchises/${franchiseId}`));
    }

    GetOffices(franchiseId: string): Promise<Office[]> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/franchises/${franchiseId}/offices`));
    }
}

export { FranchiseAPI }